<template>
    <div class="margin-t-2">
        <label class="text-s text-color-weak" :for="field.name" :class="{ 'optional': !field.required }">{{ field.label }}</label>
        <template v-if="field.values">
            <div class="flex" v-for="(value, index) in field.values">
                <input type="radio" :id="field.name + '_' + index" :value="value.value" class="nc-radio" v-model="field.value" />
                <label :for="field.name + '_' + index">{{ value.label }}</label>
            </div>
        </template>
        <template v-else>
            <div class="flex">
                <input type="radio" id="yes" value="yes" class="nc-radio" v-model="field.value" />
                <label for="yes">Yes</label>
            </div>
            <div class="flex">
                <input type="radio" id="no" value="no" class="nc-radio" v-model="field.value" />
                <label for="no">No</label>
            </div>
        </template>
        <p v-if="!field.isValid" class="error">This field is required.</p>
    </div>
</template>

<script setup>
const props = defineProps({
    field: {
        type: Object,
        default: {}
    }
})

</script>
